export default {
  imageGallery: {
    open: false,
    photos: null,
  },
};
